const NavLinks = {
  TIME_STANDARDS_ROOT: '/timestandards',
  TIME_STANDARDS_SEARCH: '/timestandards/search',
  TIME_STANDARDS_DETAIL: '/timestandards/detail',
  TIME_STANDARDS_AGE_GROUP: '/timestandards/agegroup',
  TIME_STANDARDS_AGE_GROUP_ADD: '/timestandards/agegroup/add',
  TIME_STANDARDS_AGE_GROUP_CUTS: '/timestandards/agegroup/cuts'
};

export default NavLinks;